export const StationStatus = {
  state: {
    ERROR: -3,
    DISCONNECTED: -2,
    CONNECTING: -1,
    CONNECTED: 0,
    AVAILABLE_DATA: 1,
    SPECTRUM_CLEAN: 2,
    INTERFERENCE_DETECTED: 3,
    SPOOFING_DETECTED: 4,
    SPOOFING_AND_INTERFERENCE_DETECTED: 5,
    DATA_UNAVAILABLE: 6,
    RF_STATUS_UNAVAILABLE: 7,
  },
  warning: {
    NO_WARNING: 10,
    SIS_STATION_UNREACHABLE: 11,
    INT_STATION_UNREACHABLE: 12,
    BOTH_STATIONS_UNREACHABLE: 13,
    RTK_UNREACHABLE : 14,
    SPECTROGRAM_UNAVAILABLE : 15,
  },
};

export const AlertState = {
  FIRING: "FIRING",
  STOPPED: "STOPPED",
};